import { type CanvasElement } from '@blaze-runtime/engine-domain';
import { deepClone } from '@blaze-shared/shared-util';
import { type Connection, type Workflow } from '@blaze-shared/workflow-domain';

import { getElementToWorkflowConnection } from '../../utils/elements/element.utils';
import { processWorkflowInputs } from '../page/workflow-with-inputs';

export interface WiredActionWorkflow {
  workflow: Workflow;
  connection: Connection;
  hasUpdates: boolean;
}

export function wireGeneratedActionWorkflow(
  workflow: Workflow,
  element: CanvasElement,
): WiredActionWorkflow {
  const connection = getElementToWorkflowConnection(element.id, workflow.id, element.type);
  const wired = deepClone(workflow);
  const hasUpdates = processWorkflowInputs(wired, connection, { [element.id]: element.id });

  return { workflow: hasUpdates ? wired : workflow, connection, hasUpdates };
}
